const cacheKeys = {
  all: ['hotlinks'],
  list: () => [...cacheKeys.all, 'list']
}

export default {
  endpoint: (networkId) => `/networks/${networkId}/hot-links`,
  cacheKeys
}
